import React, { useState, useEffect, memo, useMemo } from "react";
import { Table, Select, Menu, Dropdown, Button, DatePicker } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import axios from "axios";
import $ from "jquery";
import "./ParticipantStatus.css";
import Bridge from "../../../constants/Bridge";
import moment from "moment";

const { Option } = Select;

const styleSheet = document.createElement("style");
styleSheet.textContent = `
  .ant-select-arrow {
    margin-top: 0 !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
  .ant-select-selection-item {
    text-align: left !important;
  }
  .ant-picker {
    display: flex !important;
    align-items: center !important;
  }
  .ant-picker-input {
    display: flex !important;
    align-items: center !important;
  }
  .ant-picker-suffix {
    margin-top: 0 !important;
    position: absolute !important;
    right: 11px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
  .filter-select-menu .ant-select-arrow {
    margin-top: 0 !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    right: 11px !important;
    margin-top: 13px !important;
  }
`;
document.head.appendChild(styleSheet);

const additionalStyles = document.createElement("style");
additionalStyles.textContent = `
  .ant-picker {
    padding: 0 8px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .ant-picker-input {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .ant-picker-input > input {
    text-align: left !important;
  }
  .ant-picker-suffix {
    position: absolute !important;
    right: 8px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
  .ant-select-selection-item {
    text-align: left !important;
  }
  .ant-select-item-option-content {
    text-align: left !important;
  }
`;
document.head.appendChild(additionalStyles);

// Add custom styles for filter status dropdown arrow
const filterStatusStyles = document.createElement("style");
filterStatusStyles.textContent = `
  .filter-status-select .ant-select-arrow {
    position: absolute;
    top: 50%;
    right: 11px;
    transform: translateY(-50%);
    margin-top: 13px !important;
  }
`;
document.head.appendChild(filterStatusStyles);

// Add global styles for dropdown alignment
const dropdownStyles = document.createElement("style");
dropdownStyles.textContent = `
  .ant-select-dropdown {
    text-align: left !important;
  }
  .ant-select-item {
    text-align: left !important;
  }
  .ant-select-selection-item {
    text-align: left !important;
  }
  .ant-select-item-option-content {
    text-align: left !important;
  }
`;
document.head.appendChild(dropdownStyles);

// Add styles for selected items in dropdown
const selectedItemStyles = document.createElement("style");
selectedItemStyles.textContent = `
  .ant-select-selection-item {
    background: #f0f0f0 !important;
    border-radius: 4px !important;
    border: 1px solid #d9d9d9 !important;
    margin: 2px 4px 2px 0 !important;
    padding: 0 8px !important;
    height: 24px !important;
    line-height: 22px !important;
    display: flex !important;
    align-items: center !important;
  }

  .ant-select-selection-item-remove {
    color: rgba(0, 0, 0, 0.45) !important;
    margin-left: 4px !important;
  }

  .ant-select-selection-item-remove:hover {
    color: rgba(0, 0, 0, 0.85) !important;
  }

  .ant-select-selection-overflow {
    flex-wrap: wrap !important;
    gap: 2px !important;
    padding: 2px 4px !important;
  }
`;
document.head.appendChild(selectedItemStyles);

// Add styles for smaller select tags
const smallTagStyles = document.createElement("style");
smallTagStyles.textContent = `
  .ant-select-selection-item {
    height: 20px !important;
    line-height: 18px !important;
    font-size: 12px !important;
    padding: 0 6px !important;
    margin: 2px 4px 2px 0 !important;
  }

  .ant-select-selection-item-remove {
    font-size: 10px !important;
    margin-left: 4px !important;
  }

  .ant-select-selection-overflow-item-rest {
    height: 20px !important;
    line-height: 18px !important;
    font-size: 12px !important;
  }
`;
document.head.appendChild(smallTagStyles);

const IndependentStatusSelect = memo(({ initialValue }) => {
  const [value, setValue] = React.useState(initialValue || 'Pending Consent');

  const options = [
    'Pending Consent',
    'Shipment Pending',
    'Onboarded',
    'Data collection',
    'Enrolled',
    "Shipped",
    "Recieved",
  ];

  const handleStatusChange = async (newValue) => {
    try {
      setValue(newValue);
      // Add API call to update status
      await Bridge.myStudies.updateParticipantStatus({
        status: newValue
      });
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '80%', marginBottom: 30 }}>
      <Select
        value={value}
        onChange={handleStatusChange}
        style={{
          width: '100%'
        }}
        dropdownStyle={{
          padding: '12px 0',
          textAlign: 'left'
        }}
        size="small"
        placeholder="Select Status"
        popupClassName="status-select-dropdown"
      >
        {options.map(option => (
          <Option
            key={option}
            value={option}
            style={{ textAlign: 'left' }}
          >
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
});

const IndependentDatePicker = memo(({ initialValue }) => {
  const [date, setDate] = useState(initialValue ? new Date(initialValue) : null);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // height: '32px',
      position: 'relative'
    }}>
      <DatePicker
        value={date ? moment(date) : null}
        onChange={(value) => setDate(value ? value.toDate() : null)}
        style={{
          width: '100%',
        }}
        inputStyle={{
          height: '24px',
          lineHeight: '24px',
          textAlign: 'left'
        }}
        size="small"
        format="MM/DD/YYYY"
        placeholder="-"
      />
    </div>
  );
});

const IndependentSpeechSelect = memo(({ initialValue }) => {
  const [value, setValue] = React.useState(initialValue || '');

  const speechOptions = [
    'Session A',
    'Script A',
    'Script B'
  ];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '22px',
      padding: '0 4px',
      marginBottom: 30
    }}>
      <Select
        value={value}
        onChange={setValue}
        style={{
          width: '100%',
          textAlign: 'left'
        }}
        size="small"
        placeholder="-"
        dropdownStyle={{ textAlign: 'left' }}
      >
        {speechOptions.map(option => (
          <Option
            key={option}
            value={option}
            style={{ textAlign: 'left' }}
          >
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
});

const IndependentGaitSelect = memo(({ initialValue }) => {
  const [value, setValue] = React.useState(initialValue || '');

  const gaitOptions = [
    'Completed',
    'Not Completed',
    'Non-Ambulatory'
  ];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '22px',
      padding: '0 4px',
      marginBottom: 30
    }}>
      <Select
        value={value}
        onChange={setValue}
        style={{
          width: '100%',
          textAlign: 'left'
        }}
        size="small"
        placeholder="-"
        dropdownStyle={{ textAlign: 'left' }}
      >
        {gaitOptions.map(option => (
          <Option
            key={option}
            value={option}
            style={{ textAlign: 'left' }}
          >
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
});

const IndependentSpeechPostSelect = memo(({ initialValue }) => {
  const [value, setValue] = React.useState(initialValue || '');

  const speechOptions = [
    'Session A',
    'Script A',
    'Script B'
  ];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '22px',
      padding: '0 4px',
      marginBottom: 30
    }}>
      <Select
        value={value}
        onChange={setValue}
        style={{
          width: '100%',
          textAlign: 'left'
        }}
        size="small"
        placeholder="-"
        dropdownStyle={{ textAlign: 'left' }}
      >
        {speechOptions.map(option => (
          <Option
            key={option}
            value={option}
            style={{ textAlign: 'left' }}
          >
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
});

const ParticipantStatus = () => {
  // State management
  const [participantIdFilter, setParticipantIdFilter] = useState([]);
  const [visitTypeFilter, setVisitTypeFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [lastUpdated, setLastUpdated] = useState(
    new Date().toLocaleDateString()
  );
  const [type, setType] = useState("active");
  const [researchBy, setResearchBy] = useState("modality.ai");
  const [participantData, setParticipantData] = useState([]);
  const [participantIds, setParticipantIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  // Effects
  useEffect(() => {
    // Handle responsive sidebar
    const handleResize = () => {
      if (window.innerWidth < 600) {
        $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
      } else {
        $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    fetchParticipantStatus();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch participant status data
  const fetchParticipantStatus = async () => {
    try {
      setLoading(true);
      const is_site_manager = localStorage.getItem("is_site_manager") == 'yes' ? true : false
      const sites = localStorage.getItem("sites")
      console.log("issite manager------->", is_site_manager);
      let params = '?is_site_manager=' + is_site_manager + '&sites=' + sites
      const response = await Bridge.myStudies.getParticipantList(params)
      console.log("response----->", response);
      if (response && response.data.length > 0) {
        setTotalCount(response.total_count || 0);
        const formattedData = response.data.length > 0 && response.data.map(item => ({
          key: item.id,
          participantId: item.rapa_id,
          initialStatus: item.status == "" || null ? "-" : item.status,
          ealsConsentDate: item.consent_form_signed_date == "" || null ? "-" : item.consent_form_signed_date,
          visitType: item.visit_type || '',
          alsfrsR: item.rapa_alsfrs_total_score || '-',
          roads: item.road_total_score || '-',
          firstSessionFVC: item.first_fvc_session_percentage || '-',
          firstSessionSVC: item.first_svc_session_percentage || '-',
          speechPreExercise: item.speech_pre_exercise_session == "" || null ? "-" : item.speech_pre_exercise_session,
          gaitAndBalance: item.completed_25ft_walk && item.completed_6min_walk && item.completed_stair_climbing == null ? "-" :
            (<>
              <span style={{ fontWeight: 500, color: "#000" }}>
                Completed 25ft walk:  {item.completed_25ft_walk == null || "" ? "-" : <span style={{ fontWeight: 500, color: "#000" }}>{item.completed_25ft_walk=="yes"?"Yes":"No"}</span>} <br />
                Completed 6min walk: {item.completed_6min_walk == null || "" ? "-" : <span style={{ fontWeight: 500, color: "#000" }}>{item.completed_6min_walk == "yes" ? "Yes" :"No"}</span>} <br />
                Completed stair climbing: {item.completed_stair_climbing == null || "" ? "-" : <span style={{ fontWeight: 500, color: "#000" }}>{item.completed_stair_climbing == "yes" ? "Yes" : "No "}</span>} <br />
              </span>
            </>),
          speechPostExercise: item.post_exercise_session,
          secondSessionFVC: item.second_fvc_session_percentage || '-'
        }));

        // Extract unique participant IDs
        const uniqueParticipantIds = [...new Set(response.data.map(item => item.rapa_id))]
          .filter(id => id && id.trim() !== ''); // Filter out empty or null values
        setParticipantIds(uniqueParticipantIds);

        console.log('Formatted Data:', formattedData);
        setParticipantData(formattedData);
      }
    } catch (error) {
      console.error('Error fetching participant status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (value, recordKey) => {
    // Removed this function as it's not being used
  };

  const columns = [
    {
      title: "RAPA ID",
      dataIndex: "participantId",
      key: "participantId",
      fixed: "left",
      width: 110,
      render: (text) => (
        <span style={{ fontWeight: 500, color: "#000" }}>
          {text && text.trim() !== '' ? text : '-'}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      fixed: window.innerWidth > 650 ? "left" : false,

      render: (_, record) => (
        <span style={{ fontWeight: 500, color: "#000" }}>
          {record.initialStatus && record.initialStatus.trim() !== '' && record.initialStatus !== null ? record.initialStatus : '-'}  
        </span>
      ),
    },
    {
      title: "EALS Consent Date",
      dataIndex: "ealsConsentDate",
      key: "ealsConsentDate",
      width: 150,
      render: (text) => (
        <span style={{ fontWeight: 500, color: "#000" }}>
          {text && text.trim() !== '' && text !== '-' ? text : '-'}
        </span>
      ),
    },
    {
      title: "Visit Type",
      dataIndex: "visitType",
      key: "visitType",
      width: 100,
      render: (text) => (
        <span style={{ fontWeight: 500, color: "#000" }}>
          {text && text.trim() !== '' && text !== null ? text : '-'}
        </span>
      ),
    },
    {
      title: "ALSFRS-R",
      dataIndex: "alsfrsR",
      key: "alsfrsR",
      width: 100,
      render: (text) => (
        <div style={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 500, color: "#000" }}>
            {text && text.trim() !== '' && text !== '-' ? Math.round(Number(text)) : '-'}
          </span>
        </div>
      ),
    },
    {
      title: "ROADS",
      dataIndex: "roads",
      key: "roads",
      width: 110,
      render: (text) => (
        <div style={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 500, color: "#000" }}>
            {text && text.trim() !== '' && text !== '-' ? Math.round(Number(text)) : '-'}
          </span>
        </div>
      ),
    },
    {
      title: "1st Session FVC % Predicted",
      dataIndex: "firstSessionFVC",
      key: "firstSessionFVC",
      width: 100,
      render: (text) => (
        <div style={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 500, color: "#000" }}>
            {text && text.trim() !== '' && text !== '-' ? text : '-'}
          </span>
        </div>
      ),
    },
    {
      title: "1st Session SVC % Predicted",
      dataIndex: "firstSessionSVC",
      key: "firstSessionSVC",
      width: 100,
      render: (text) => (
        <div style={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 500, color: "#000" }}>
            {text && text.trim() !== '' && text !== '-' ? text : '-'}
          </span>
        </div>
      ),
    },
    {
      title: "Speech Pre Exercise",
      dataIndex: "speechPreExercise",
      key: "speechPreExercise",
      width: 110,
      render: (text, record) => (
        <span style={{ fontWeight: 500, color: "#000" }}>
          {text && text.trim() !== '' && text !== '-' ? text : '-'}
        </span>
      ),
    },
    {
      title: "Gait And Balance",
      dataIndex: "gaitAndBalance",
      key: "gaitAndBalance",
      width: 190,
      render: (text, record) => (
        <div>
          {text}
        </div >

      ),
    },
    {
      title: "Speech Post Exercise",
      dataIndex: "speechPostExercise",
      key: "speechPostExercise",
      width: 110,
      render: (text) => (
        <span style={{ fontWeight: 500, color: "#000" }}>
          {text && text.trim() !== '' && text !== '-' ? text : '-'}
        </span>
      ),
    },
    {
      title: "2nd Session FVC % Predicted",
      dataIndex: "secondSessionFVC",
      key: "secondSessionFVC",
      width: 100,
      render: (text) => (
        <div style={{ textAlign: 'left' }}>
          <span style={{ fontWeight: 500, color: "#000" }}>
            {text && text.trim() !== '' && text !== '-' ? text : '-'}
          </span>
        </div>
      ),
    },
  ];

  // Status tag renderer
  const renderStatusTag = (status) => {
    if (!status) return <span>-</span>;
    const statusClass =
      status === "Complete" ? "status-complete" : "status-pending";
    return <span className={`status-tag ${statusClass}`}>{status}</span>;
  };

  // Table action menu
  const getActionMenu = (record) => (
    <Menu>
      <Menu.Item
        key="edit"
        onClick={() => handleEditRecord(record)}
      >
        <i className="fas fa-edit" /> Edit Details
      </Menu.Item>
      <Menu.Item
        key="delete"
        onClick={() => handleDeleteRecord(record)}
        style={{ color: '#ff4d4f' }}
      >
        <i className="fas fa-trash-alt" /> Delete Entry
      </Menu.Item>
    </Menu>
  );

  // Handle edit record
  const handleEditRecord = (record) => {
    console.log('Edit record:', record);
    // Add your edit logic here
  };

  // Handle delete record
  const handleDeleteRecord = (record) => {
    console.log('Delete record:', record);
    // Add your delete logic here
  };

  // Define visit type options
  const visitTypeOptions = [
    'Base line 1',
    'Base line 2',
    'Base line 3',
    'C1D1 24 Hr Post Session',
    'C2D1 24 Hr Post Session',
    'C3D1 24 Hr Post Session',
    'C4D1 24 Hr Post Session',
    'Recurring Session',
    'Recurring Session1',
    'Apheresis Day 0',
    "C1D1",
    "C2D1",
    "C3D1",
    "C4D1",
    "Onboarding 1"
  ];

  // Filter data based on selected participant IDs and visit type
  const filteredData = useMemo(() => {
    let filtered = participantData;

    console.log('Current status filter:', statusFilter);

    if (participantIdFilter && participantIdFilter.length > 0) {
      filtered = filtered.filter(item =>
        item.participantId &&
        item.participantId.trim() !== '' &&
        participantIdFilter.includes(item.participantId)
      );
    }

    if (visitTypeFilter) {
      filtered = filtered.filter(item =>
        item.visitType === visitTypeFilter
      );
    }

    // Filter by status
    // Filter by status
    // Filter by status
    // Filter by status
    if (statusFilter) {
      console.log('Filtering by status:', statusFilter);
      filtered = filtered.filter(item => {
        console.log('Item status:', item.initialStatus);
        if (statusFilter === "Enrolled") {
          return item.initialStatus === "Enrolled" || item.initialStatus === "Enrolled in RAPA";
        } else if (statusFilter === "Shipment Ready") {
          return item.initialStatus === "Shipment Ready" || item.initialStatus === "Ready to Ship";
        } else if (statusFilter === "Received") {
          return item.initialStatus === "Received"; // Add any other related statuses if needed
        } else {
          return item.initialStatus === statusFilter;
        }
      });
    }
    setTotalCount(filtered.length);

    return filtered;
  }, [participantData, participantIdFilter, visitTypeFilter, statusFilter]);

  const statusOptions = ['Complete', 'Pending'];

  return (
    <div className="participant-activity-div radcliff-participant-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-lg-10 participant-right-section-wrapper">
          <div className="inner-wrapper">
            <div className="row top-space">
              <div className="col-lg-1"></div>
              <div className="col-lg-11">
                <div className="ambassador-heading-section mb-3">
                  <h3
                    style={{
                      position: "relative",
                      fontSize: 28,
                      fontFamily: "Open Sans",
                      fontWeight: "bold",
                      color: "#1A4F83",
                      textAlign: "start",
                    }}
                    className="mb-3"
                  >
                    Participant Status (Total       {totalCount})
                  </h3>
                </div>
              </div>
            </div>
            <div className="content">
              <div className="row align-items-center justify-content-around">
                <div className="col-lg-1"></div>
                <div className="col-lg-3 filter-by-activity-input-wrapper">
                  <div className="filter-by-activity-input">
                    <label className="filter-label" style={{ fontSize: '14px' }}>
                      Filter By RAPA ID
                    </label>
                    <Select
                      mode="multiple"
                      showSearch
                      allowClear
                      style={{ width: 300 }}
                      placeholder="Select RAPA IDs"
                      value={participantIdFilter}
                      onChange={(values) => {
                        setParticipantIdFilter(values);
                      }}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().includes(input.toLowerCase())
                      }
                      maxTagCount={3}
                      maxTagPlaceholder={(omitted) => `+${omitted}`}
                      labelInValue={false}
                    >
                      {participantIds.filter(Boolean).map((id) => (
                        <Select.Option key={id} value={id}>
                          {id}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-3 filter-by-independant-coach-input" style={{ marginBottom: "7px", marginLeft: "15px" }}>
                  <label style={{ marginLeft: 20, fontSize: '14px' }}>Filter By Visit Type</label>
                  <Select
                    showSearch
                    placeholder="Select type"
                    value={visitTypeFilter}
                    onChange={setVisitTypeFilter}
                    allowClear
                    style={{ width: "100%", marginLeft: 20 }}
                    className="filter-element mb-3 filter-select-menu"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {visitTypeOptions.map((type) => (
                      <Option key={type} value={type}>
                        {type}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="col-12 col-sm-12 col-lg-4 filter-by-column-input-wrapper">
                  <label style={{ fontSize: '14px' }}>Filter By Status</label>
                  <Select
                    showSearch
                    placeholder="Select status"
                    value={statusFilter}
                    onChange={setStatusFilter}
                    allowClear
                    style={{ width: "100%" }}
                    className="filter-element filter-status-select"
                    dropdownStyle={{ textAlign: 'left' }}
                  >
                    <Option value="Pending Consent">Pending Consent</Option>
                    <Option value="Shipment Pending">Shipment Pending</Option>
                    <Option value="Onboarded">Onboarded</Option>
                    <Option value="Data Collection">Data Collection</Option>
                    <Option value="Received">Received</Option>
                    <Option value="Enrolled">Enrolled</Option>
                    <Option value="Shipment Ready">Shipment Ready</Option>
                    <Option value="Shipped">Shipped</Option>


                  </Select>
                </div>
              </div>
              <div className="row participant-activity-table">
                <div className="col-lg-11 mt-5" style={{ marginLeft: "auto" }}>
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    loading={loading}
                    rowKey="key"
                    scroll={{ x: 1800 }}
                    pagination={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantStatus;
